// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__sasGA","info":"form_info__rrin1","label":"form_label__hJa-2","formWrapper":"form_formWrapper__u4GmT","opacity-transition":"form_opacity-transition__+p7JL"};